import { FormSection } from '@/containers/forms/FormSection'
import type { BaseContainerProps } from '.'
import { HouseholdForm } from '../forms/HouseholdForm'

export const Household = (props: BaseContainerProps) => {
  return (
    <FormSection {...props}>
      <HouseholdForm />
    </FormSection>
  )
}